import { IATMTransactionInquiryDatatableDetailsMeta } from '@Modules/admin/archiving/containers/mixedHandlers/archivedTables/atmTransactionInquiry/ATMTransactionInquiryDatatableDetailsMeta';
import { TATMTransactionInquiryDataTableData } from '@Modules/admin/archiving/containers/mixedHandlers/archivedTables/atmTransactionInquiry/ATMTransactionInquiryDatatableMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import displayCustomField from '@Shared/utils/displayCustomFields';
import { getDetailName } from '@Shared/utils/getDetailName';
import React from 'react';

type Props = {
    meta: IATMTransactionInquiryDatatableDetailsMeta,
    data: TATMTransactionInquiryDataTableData
}
// & TFormUIProps;

export default React.forwardRef(function ATMTransactionInquiryTableDetailsUI ({ meta, data }: Props, ref: any) {

  const part1Informations = React.useMemo(() => getDetailName(meta).slice(0, 18), [meta]);
  const part2Informations = React.useMemo(() => getDetailName(meta).slice(18, 20), [meta]);

  return (
    <CC.Box my="4" mb='8'>
      <CC.SimpleGrid columns={{ base: 1, md:2, lg: 3 }} gridRowGap={4} columnGap={10} my={4}>
          {displayCustomField<IATMTransactionInquiryDatatableDetailsMeta>(
          meta, part1Informations
          )}
      </CC.SimpleGrid>

      <CC.Divider/>
      
      <CC.SimpleGrid columns={{ base: 1, md:2 }} gridRowGap={4} columnGap={10} my={4}>
          {displayCustomField<IATMTransactionInquiryDatatableDetailsMeta>(
          meta, part2Informations
          )}
      </CC.SimpleGrid>

    </CC.Box>
  );
});

// export default ATMTransactionInquiryFormUI;
